import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "fill-height",
    class: _vm.color,
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticClass: "fill-height",
    style: _vm.getBG(),
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCard, {
    attrs: {
      "flat": ""
    }
  }, [_c(VCardTitle, [_c(VIcon, {
    attrs: {
      "color": "white",
      "size": "80"
    }
  }, [_vm._v("fal fa-exclamation-triangle")])], 1), _c(VCardText, [_c('h1', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.oops1')) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.oops2')) + "\n        ")])]), _c(VCardActions, {
    staticClass: "justify-center"
  }, [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "to": "/home",
      "color": _vm.color,
      "rounded": "",
      "text": ""
    }
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-backward")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.backToHome')) + "\n        ")], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };